import { ToolbarActionsLane } from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import {
  PrimaryControlsStripBackControl,
  usePrimaryControlsStripBackGate,
} from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { PrimaryControlsStripToolbar } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";
import { PrimaryControlsStripTitle } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.title";
import { GraphemeFontGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.font";
import { useGetGraphemeGlyph } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.glyph/client";
import { View } from "@-/com.npmjs.react-native";
import { WordReferenceView } from "#word-reference-view";

// Word cards have only a info view (no mnemonics), so there is no local TabView panel
// switcher — the info view renders directly under the word header.
export function WordMorphemePanelsView({ word }: { word: string }) {
  const getGraphemeGlyph = useGetGraphemeGlyph();
  // Tone color lives on dictionary-tab pinyin only — the header glyph stays plain foreground.
  const wordGlyph = getGraphemeGlyph(word, { uncolored: true });
  const backGate = usePrimaryControlsStripBackGate({ appShellPlacement: "toolbar" });

  return (
    <>
      <PrimaryControlsStripTitle>
        <GraphemeFontGlyph
          className="text-center text-[36px] leading-12.5 text-foreground"
          glyph={wordGlyph}
        />
      </PrimaryControlsStripTitle>
      <PrimaryControlsStripToolbar>
        <ToolbarActionsLane>
          {backGate !== null && (
            <PrimaryControlsStripBackControl gate={backGate} layout="app-shell" />
          )}
        </ToolbarActionsLane>
      </PrimaryControlsStripToolbar>
      <View className="min-h-0 flex-1 flex-col bg-background">
        <WordReferenceView rawWord={word} />
      </View>
    </>
  );
}
